<template>
    <v-card outlined rounded="lg">
        <div class="pa-20 pa-md-24">
            <v-row align="center" class="row--x-large">
                <v-col cols="12" lg="" class="recruitment-item__detail mb-10 mb-lg-0">
                    <h5 class="page-text--lg font-weight-medium mb-4">
                        {{ value?.title }}
                    </h5>
                    <v-row align="center" class="row--small mb-4">
                        <v-col cols="auto" class="applied-card__link">
                            <p class="page-text grey-6--text">매칭URL: {{ matchUrl }}</p>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn text icon small color="grey" @click="copy(matchUrl)"> <v-icon>mdi-content-copy</v-icon> </v-btn>
                        </v-col>
                    </v-row>
                    <meeting-list-item-matching v-bind="{ value }" />
                </v-col>
                <v-col cols="12" md="9" lg="auto" class="mb-10 mb-md-0">
                    <v-row class="row--large">
                        <v-col cols="12" md="4" lg="auto" class="mb-4 mb-md-0">
                            <meeting-list-item-state v-bind="{ value }" v-on="{ put }" />
                        </v-col>
                        <v-col cols="12" md="8" lg="auto">
                            <meeting-list-item-counts v-bind="{ value }" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4" lg="auto">
                    <v-row class="row--small">
                        <v-col cols="6" md="12" lg="auto">
                            <meeting-view v-bind="{ value }" @input="(value) => $emit('input', value)">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="attrs" v-on="on" outlined small block color="grey-d" class="min-w-lg-100px">
                                        <span class="grey-6--text">미팅정보 수정</span>
                                    </v-btn>
                                </template>
                            </meeting-view>
                        </v-col>
                        <v-col cols="6" md="12" lg="auto">
                            <meeting-status v-bind="{ value }" @input="(value) => $emit('input', value)">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="attrs" v-on="on" outlined small block color="primary" class="min-w-lg-100px">미팅현황</v-btn>
                                </template>
                            </meeting-status>
                        </v-col>
                        <v-col cols="12" md="12" lg="auto">
                            <texting-dialog v-bind="textingProps">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="attrs" v-on="on" outlined small block color="grey-d" class="min-w-lg-100px">
                                        <span class="grey--text">문자발송</span>
                                    </v-btn>
                                </template>
                            </texting-dialog>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>

        <!-- <v-row align="center" class="row--x-large">
            <v-col>
                <v-card-title class="page-text--lg pa-0">{{ value?.title }}</v-card-title>
                <v-card-subtitle class="pa-0 ma-0 py-4">
                    매칭URL: {{ matchUrl }}
                    <v-icon @click="copy(matchUrl)">mdi-content-copy</v-icon>
                </v-card-subtitle>
                <v-card-text class="pa-0">
                    <meeting-list-item-matching v-bind="{ value }" />
                </v-card-text>
            </v-col>
            <v-col cols="12" lg="auto" class="pa-0 py-10 pa-md-20">
                <meeting-list-item-state v-bind="{ value }" v-on="{ put }" />
            </v-col>
            <v-col cols="12" lg="auto">
                <meeting-list-item-counts v-bind="{ value }" />
            </v-col>
            <v-col cols="12" lg="auto" class="">
                <v-row class="row--small">
                    <v-col cols="6" md="auto">
                        <meeting-view v-bind="{ value }" @input="(value) => $emit('input', value)">
                            <template #activator="{ attrs, on }">
                                <v-btn class="font-size-14 grey-6--text page-text--sm pa-12" outlined v-bind="attrs" v-on="on">미팅정보 수정</v-btn>
                            </template>
                        </meeting-view>
                    </v-col>
                    <v-col cols="6" md="auto">
                        <meeting-status v-bind="{ value }" @input="(value) => $emit('input', value)">
                            <template #activator="{ attrs, on }">
                                <v-btn outlined color="primary" class="font-size-14" v-bind="attrs" v-on="on"> 미팅현황 </v-btn>
                            </template>
                        </meeting-status>
                    </v-col>
                </v-row>
            </v-col>
        </v-row> -->
    </v-card>
</template>

<script>
import MeetingView from "../view/meeting-view.vue";
import MeetingStatus from "../status/meeting-status.vue";
import TextingDialog from "../../texting/texting-dialog.vue";
import MeetingListItemState from "./meeting-list-item-state.vue";
import MeetingListItemCounts from "./meeting-list-item-counts.vue";
import MeetingListItemMatching from "./meeting-list-item-matching.vue";

export default {
    components: {
        MeetingView,
        MeetingStatus,
        TextingDialog,
        MeetingListItemState,
        MeetingListItemCounts,
        MeetingListItemMatching,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // meeting
        put: { type: Function, default: () => () => {} },
    },
    computed: {
        matchUrl() {
            return `${window.location.origin}/meetings/${this.value?._id}`;
        },
        textingProps() {
            const { _id: _meeting, recruitment, applications } = this.value;
            return {
                value: applications,
                meeting: this.value,
                recruitment,
                applications,
                paramsProps: {
                    _meeting,
                },
            };
        },
    },
    methods: {
        copy(string) {
            navigator.clipboard.writeText(string);
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .recruitment-item__detail {
        max-width: calc(100% - 933px);
    }
}
@media (min-width: 1200px) {
}
</style>

